var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#d10000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9853 32.573C28.128 32.4073 28.2065 32.1959 28.2065 31.9772V25.3697C28.2065 25.1391 28.2938 24.9169 28.4508 24.748L36.8245 15.74C37.3675 15.1558 36.9532 14.2051 36.1557 14.2051H15.8006C15.0096 14.2051 14.5927 15.1422 15.1223 15.7296L23.2536 24.7503C23.4048 24.918 23.4885 25.1358 23.4885 25.3617V35.3353C23.4885 36.182 24.5411 36.5728 25.0936 35.9311L27.9853 32.573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.e92f189768a05c0929c1abb384f39522.svg";
export { ForwardRef as ReactComponent };